import React from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'

const Footer: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const scrollToSection = (sectionId: string) => {
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId)
      if (element) {
        const offset = 80
        const elementPosition = element.getBoundingClientRect().top
        const offsetPosition = elementPosition + window.pageYOffset - offset
        window.scrollTo({ top: offsetPosition, behavior: 'smooth' })
      }
    } else {
      navigate('/', { state: { scrollTo: sectionId } })
    }
  }

  return (
    <footer className="bg-black border-t-0">
      <div className="racing-stripe w-full" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="py-10 md:py-14">
          {/* Top area */}
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8 mb-8">
            {/* Logo & description */}
            <div className="max-w-xs">
              <Link to="/" className="flex items-center gap-2 mb-3">
                <div
                  className="w-8 h-8 rounded-lg flex items-center justify-center relative"
                  style={{ background: 'linear-gradient(135deg, #e11d48, #f97316)' }}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="10.5" cy="10.5" r="7"/>
                    <line x1="15.5" y1="15.5" x2="21" y2="21" strokeWidth="2.5"/>
                    <path d="M6 12.5h9M7.5 12.5l.8-2.5h5.4l.8 2.5" strokeWidth="1.2"/>
                    <circle cx="8.5" cy="12.5" r=".8" fill="white" strokeWidth="0"/>
                    <circle cx="12.5" cy="12.5" r=".8" fill="white" strokeWidth="0"/>
                  </svg>
                </div>
                <span className="font-bold text-lg text-white">BMWFinder</span>
              </Link>
              <p className="text-sm text-neutral-400 leading-relaxed">
                Find your dream BMW from dealerships nationwide. E, F, and G chassis with individual colors, bucket seats, and more.
              </p>
            </div>

            {/* Links */}
            <div className="flex gap-12">
              <div>
                <h4 className="text-xs font-semibold text-neutral-500 uppercase tracking-wider mb-3">Product</h4>
                <ul className="space-y-2.5">
                  <li>
                    <button
                      onClick={() => scrollToSection('features')}
                      className="text-sm text-neutral-400 hover:text-white transition-colors bg-transparent border-none cursor-pointer p-0"
                    >
                      Features
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => scrollToSection('faq')}
                      className="text-sm text-neutral-400 hover:text-white transition-colors bg-transparent border-none cursor-pointer p-0"
                    >
                      FAQ
                    </button>
                  </li>
                </ul>
              </div>
              <div>
                <h4 className="text-xs font-semibold text-neutral-500 uppercase tracking-wider mb-3">Legal</h4>
                <ul className="space-y-2.5">
                  <li>
                    <Link to="/terms" className="text-sm text-neutral-400 hover:text-white transition-colors">
                      Terms
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact" className="text-sm text-neutral-400 hover:text-white transition-colors">
                      Contact
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Bottom area */}
          <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div className="space-y-1">
              <p className="text-sm text-neutral-500">&copy; {new Date().getFullYear()} BMWFinder. All rights reserved.</p>
              <p className="text-xs text-neutral-500">
                Not associated with any dealership. All trademarks are property of their respective owners.
              </p>
            </div>
            <p className="text-xs text-neutral-500">
              Data refreshed every hour
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
